// Types
import { Action } from "../actions/types";

// Type state
type State = {
  stopped: boolean;
  loaded: boolean;
};

// Initial state
const INITIAL_STATE: State = {
  stopped: false,
  loaded: false,
};

export default (state: State = INITIAL_STATE, action: Action): State => {
  switch (action.type) {
    case "EDIT_COMPANY_EFT_PULL":
      return {
        ...state,
        stopped: Boolean(action.data?.stopped),
        loaded: true,
      };
    case "CLEAR_COMPANY_EFT_PULL":
      return INITIAL_STATE;
    default:
      return state;
  }
};
